export const TOUR_IDS = {
  platformSelect: "platformSelect",
  organizationSelect: "organizationSelect",
  favorites: "favorites",
  features: "features",
  targetPage: "targetPage",
  onboarding: "onboarding",
};
